import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  GetPendingComplaintList,
  IMG_BASE_URL1,
  UpdateApproveRejectComplaint,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'


const ComplaintAppPendingList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchComplaintAppPendingList()
  }, [])

  const fetchComplaintAppPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetPendingComplaintList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        wh_mobile: item.wh_mobile,
        subject: item.subject,
        complaint_date: item.complaint_date,

        // 👉 Correct date format (YYYY-MM-DD)
        complaint_date: item.complaint_date
          ? new Date(item.complaint_date).toISOString().split('T')[0]
          : '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.wh_mobile ?? '').toString().includes(search) ||
      (item.subject ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'wh_mobile' },
    { title: 'Subject', dataIndex: 'subject' },
    { title: 'Complaint Date', dataIndex: 'complaint_date' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const updateComplaintStatus = async (status) => {
    if (!selectedRecord) return

    setLoading(true)
    try {
      const res = await axios.put(
        `${UpdateApproveRejectComplaint}/${selectedRecord.id}`,
        { status }, // sending status 2 or 3
      )
      if (res.data == 'RESOLVED') {
        toast.success('Complaint approved successfully!')
        setViewModalOpen(false)
        setConfirmChecked(false)
        fetchComplaintAppPendingList()
      } else if (res.data == 'DELETED') {
        toast.success('Complaint rejected successfully!')
        setViewModalOpen(false)
        setConfirmChecked(false)
        fetchComplaintAppPendingList()
      } else if (res.data == 'NOTFOUND') {
        toast.warn('Data Not Found!')
      }
    } catch (err) {
      toast.error('Failed to update complaint status')
    } finally {
      setLoading(false)
    }
  }

  // =======CSS==========

  const labelCss = {
    fontWeight: '600',
  }

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Complaint Approval Pending',
    )

    XLSX.writeFile(workbook, 'Complaint_Approval_Pending_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Complaint Resolve Pending List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row">
                  <div className="col-md-6 pb-2">
                    <span style={labelCss}>Full Name :</span>
                    <br />
                    <span
                      style={{
                        backgroundColor: '#f8ff90',
                        padding: '2px 10px',
                        fontSize: '16px',
                      }}
                    >
                      {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                      {selectedRecord.s_lname}
                    </span>
                  </div>
                  <div className="col-md-6 pb-2">
                    <span style={labelCss}>WhatsApp No :</span>
                    <br /> {selectedRecord.wh_mobile || '-'}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 pb-2">
                    <span style={labelCss}>Complaint Date :</span>
                    <br /> {selectedRecord.complaint_date}
                  </div>
                  <div className="col-md-6 pb-2">
                    <span style={labelCss}>Subject :</span>
                    <br /> {selectedRecord.subject}
                  </div>
                  <div className="col-md-12 pb-2">
                    <span style={labelCss}>Description :</span>
                    <br /> {selectedRecord.description}
                  </div>
                  <div className="col-md-12 pb-2">
                    <span style={labelCss}>Image :</span> <br />
                    <img
                      src={`${IMG_BASE_URL1}${selectedRecord.upload_img}`}
                      alt="Payment"
                      style={{
                        width: '300px',
                        borderRadius: '10px',
                        border: '1px solid #ddd',
                        marginTop: '10px',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  type="primary"
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => updateComplaintStatus(2)}
                >
                  Resolve
                </Button>

                <Button
                  danger
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => updateComplaintStatus(3)}
                >
                  Reject
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default ComplaintAppPendingList
